import { FC, LazyExoticComponent } from 'react';
import {
  getFederatedComponentProps,
  useFederatedComponents,
} from '@cnx-saas/common-fe';
import federatedModulesConfig from '../../../federated-modules.json';
import {
  DepotLoadsPieChartProps,
  ShipmentStatusCountProps,
  LocationMasterDataProps,
} from '../charts';

export function useDepotLoadsPieChartWidget() {
  const { FederatedComponent: DepotLoadsPieChartWidget } =
    useFederatedComponents<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      LazyExoticComponent<any>,
      LazyExoticComponent<FC<DepotLoadsPieChartProps>>
    >(
      getFederatedComponentProps(
        'orderManagement/DepotLoadsPieChart',
        federatedModulesConfig.dynamicRemotes,
      ),
    );

  return DepotLoadsPieChartWidget ?? null;
}

export function useShipmentStatusCountWidget() {
  const { FederatedComponent: ShipmentStatusCountWidget } =
    useFederatedComponents<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      LazyExoticComponent<any>,
      LazyExoticComponent<FC<ShipmentStatusCountProps>>
    >(
      getFederatedComponentProps(
        'shipmentExecution/ShipmentStatusCountWidget',
        federatedModulesConfig.dynamicRemotes,
      ),
    );

  return ShipmentStatusCountWidget ?? null;
}

export function useLocationMasterDataWidget() {
  const { FederatedComponent: LocationMasterDataWidget } =
    useFederatedComponents<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      LazyExoticComponent<any>,
      LazyExoticComponent<FC<LocationMasterDataProps>>
    >(
      getFederatedComponentProps(
        'orderManagement/LocationMasterDataWidget',
        federatedModulesConfig.dynamicRemotes,
      ),
    );

  return LocationMasterDataWidget ?? null;
}

export function useCurrentTransportsWidget() {
  const { FederatedComponent: CurrentTransportsWidget } =
    useFederatedComponents<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      LazyExoticComponent<any>
    >(
      getFederatedComponentProps(
        'shipmentExecution/CurrentTransportsWidget',
        federatedModulesConfig.dynamicRemotes,
      ),
    );

  return CurrentTransportsWidget ?? null;
}
